import { render } from "./NumberIcon.vue?vue&type=template&id=f6706496&scoped=true&ts=true"
import script from "./NumberIcon.vue?vue&type=script&lang=ts"
export * from "./NumberIcon.vue?vue&type=script&lang=ts"

import "./NumberIcon.vue?vue&type=style&index=0&id=f6706496&lang=scss&scoped=true"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6706496"]])

export default __exports__